<template>
  <div class="page-view" :class="{cover:selectedTag.tagValue}">

    <div class="search">
      <a class="wrap" :href="`${hostPath}/search?type=article`"><span>搜索</span></a>
    </div>

    <div class="banner" v-show="!selectedTag.tagValue">
      <a class="read" v-if="readText" :href="readUrl">
        <span>今日早读</span>
        <p>{{readText}}</p>
      </a>
    </div>

    <div class="page-cover" v-show="selectedTag.tagValue">
      <img :src="selectedTag.tagBgImage" alt="" />
    </div>

    <div class="tab-view">
      <div class="wrap">
        <div class="more" @click="show=true"></div>
        <div class="mark" v-show="show" @click="show=false">
          <div class="plane">
            <span v-for="(item,index) in tag" :key="item.tagName" :class="{active:item.tagValue === selectedTag.tagValue}" @click="selectTag(item,index)">{{item.tagName}}</span>
          </div>
        </div>
        <div class="list" id="list">
          <span v-for="(item,index) in tag" :key="item.tagName" :id="'a'+index" :class="{active:item.tagValue === selectedTag.tagValue}" @click="selectTag(item,index)">{{item.tagName}}</span>
        </div>
      </div>
    </div>

    <ul class="article">
      <li class="article-list" v-for="item in list" :key="item.articleId">
        <a :href="item.url">
          <img :src="item.image" alt="">
          <div class="info">
            <p>{{item.title}}</p>
            <div class="label"><span>{{item.pubDate}}</span><span>{{item.text}}</span></div>
          </div>
        </a>
      </li>
    </ul>

    <div class="noMore" v-show="!isLoading && pageCount === page">没有更多了</div>
    <div v-show="isLoading" style="padding:15px 0;text-align:center;font-size:13px;color:#aaa;">加载中···</div>

  </div>
</template>

<script>
import { hostPath, hostPCPath } from '@utils/basePath'
import { getArticleBanner, getArticleTags, getArticleList } from '@/api/article'
import { getUserId, PCPort, isLogin, userLogin, weixinShare } from '@/widget/index'
export default {
  data() {
    return {
      isLogin: isLogin,
      hostPath: hostPath,
      readText: '',
      readUrl: '',
      tag: [],
      selectedTag: {
        tagBgImage: '',
        tagName: '',
        tagValue: ''
      },
      show: false,
      page: 1,
      pageCount: 0,
      list: [],
      isLoading: false
    }
  },
  created() {
    if (PCPort()) {
      location.href = `${hostPCPath}/web/article`
    } else {
      if (!this.isLogin) {
        userLogin()
      } else {
        this.getBannerRequest()
        this.getTabsRequest()
        this.getArticleRequest()
      }
    }
  },
  mounted() {
    weixinShare({
      title: '3000+文章精选',
      desc: '从药物使用到手术技巧，从原理剖析到实践应用，从基础理论到专家共识，立足临床，指导实践！传授经验，共享新知！',
      url: location.href,
      image: 'https://img-a.haoyishu.com/images/share/hys_logo.png'
    })
  },
  beforeUnmount() {
    document.removeEventListener('scroll', this.requestMore, false)
  },
  methods: {
    // 页面触底判断
    scrollToBottom() {
      document.addEventListener('scroll', this.requestMore, false)
    },
    requestMore() {
      var scrollHigh =
        document.documentElement.scrollTop || document.body.scrollTop
      // 距离底部200px时触发
      if (scrollHigh + window.innerHeight >= document.body.clientHeight - 200) {
        if (this.pageCount > this.page && !this.isLoading) {
          this.page = this.page + 1
          this.getArticleRequest()
        }
      }
    },

    // 选择tab
    selectTag(item, index) {
      this.selectedTag = item
      this.show = false
      this.page = 1
      this.list = []
      this.getArticleRequest()

      const offsetLeft = document.getElementById('a' + index).offsetLeft
      const offsetWidth = document.getElementById('a' + index).offsetWidth
      const move = (offsetLeft - window.innerWidth / 2) + offsetWidth / 2
      list.scrollTo({ left: move, behavior: 'smooth' })
    },

    // 获取文章列表
    getArticleRequest() {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      getArticleList({
        params: {
          userId: getUserId(),
          page: this.page
        },
        query: {
          tag: this.selectedTag.tagValue
        }
      }).then(res => {
        if (res.code === 200) {
          this.list = [...this.list, ...res.data.list]
          this.pageCount = res.data.pageCount

          // 是否需要上拉加载
          if (this.pageCount > 1) {
            this.scrollToBottom()
          }
        } else {
          this.$toast(res.message)
        }
        this.isLoading = false
      })
    },

    // 获取tab
    getTabsRequest() {
      getArticleTags({
        params: {
          userId: getUserId()
        }
      }).then(res => {
        if (res.code === 200) {
          this.tag = res.data.tag
        } else {
          this.$toast(res.message)
        }
      })
    },

    // 获取早读推荐
    getBannerRequest() {
      getArticleBanner({
        params: {
          userId: getUserId()
        }
      }).then(res => {
        if (res.code === 200) {
          this.readText = res.data.text
          this.readUrl = res.data.article.url
        } else {
          this.$toast(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-view{
  &.cover{
    .tab-view,.search{
      background: transparent;
    }
    .tab-view{
      margin-top: -0.2rem;
    }
  }
}
.article{
  box-sizing: border-box;
  padding: 0 0.24rem;
  .article-list{
    border-bottom: 0.01rem solid #EBEBEB;
    &:last-child{
      border: none;
    }
    a{
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      padding: 0.4rem 0;
    }
    img{
      width: 2rem;
      min-width: 2rem;
      height: 1.5rem;
      border-radius: 0.08rem;
      display: block;
      object-fit: cover;
    }
    .info{
      padding-left: 0.21rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      p{
        font-size: 0.32rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 0.48rem;
      }
      .label{
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #808080;
        line-height: 0.32rem;
        display: flex;
        justify-content:space-between;
        align-items: center;
      }
    }
  }
}

.page-cover{
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: -2.3rem;
  margin-top: -1.06rem;
  z-index: 1;
  img{
    display: block;
    height: 4rem;
    width: 100%;
    object-fit: cover;
  }
}
.tab-view{
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 1.06rem;
  z-index: 5;
  background: #EFF0F2;
  .wrap{
    width: 100%;
    position: relative;
    z-index: 1;
    .mark{
      position: absolute;
      width: 100%;
      height: 100vh;
      top:0;
      left: 0;
      z-index: 2;
      background: rgba(0,0,0,0.5);
      border-radius: 0.15rem 0.15rem 0rem 0rem;
      overflow: hidden;
    }
    .more{
      position: absolute;
      top:0;
      right:0;
      z-index: 1;
      height: 0.75rem;
      width: 0.75rem;
      cursor: pointer;
      background: url('~@/assets/icon/more_classification_ic.png') no-repeat center 0.07rem;
      background-size: cover;
    }
    .plane{
      background: #fff;
      box-sizing: border-box;
      padding: 0.3rem;
      span{
        min-width: 1.5rem;
        display: inline-block;
        line-height: 0.56rem;
        margin: 0 0.19rem 0.19rem 0;
        font-size: 0.28rem;
        background: rgba(228, 229, 235, 0.5);
        color: #626366;
        border-radius: 1rem;
        text-align: center;
        box-sizing: border-box;
        padding: 0 0.2rem;
        &.active{
          color: #FF6600;
          font-weight: bold;
        }
      }
    }
    .list{
      overflow-x:scroll;
      white-space: nowrap;
      background: #fff;
      box-sizing: border-box;
      border-radius: 0.15rem 0.15rem 0rem 0rem;
      padding: 0 1rem 0 0.2rem;
      span{
        display: inline-block;
        line-height: 0.75rem;
        margin: 0 0.19rem;
        font-size: 0.28rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: #000000;
        transition: all 0.35s;
        border-bottom: 0.06rem solid transparent;
        &.active{
          border-bottom: 0.06rem solid #FF6600;
          color: #FF6600;
          font-size: 0.32rem;
        }
      }
    }
  }
}

.search{
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0rem;
  padding: 0.24rem;
  box-sizing: border-box;
  z-index: 5;
  background: #EFF0F2;
  .wrap{
    width: 100%;
    height: 0.58rem;
    background: rgba(255,255,255,0.9);
    border-radius: 0.08rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 0.24rem;
    box-sizing: border-box;
    span{
      padding-left: 0.42rem;
      display: inline-block;
      background: url('~@/assets/icon/icon_search.png') no-repeat left center;
      background-size: 0.36rem 0.36rem;
      font-size: 0.24rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #808080;
    }
  }
}

.banner{
  box-sizing: border-box;
  padding: 0 0.24rem 0.24rem 0.24rem;
  background: #EFF0F2;
  .read{
    width: 100%;
    height: 1.76rem;
    border-radius: 0.08rem;
    background: url('~@/assets/icon/bg.png') no-repeat center center;
    background-size: cover;
    box-sizing: border-box;
    padding: 0.2rem;
    display: block;
    span{
      padding-left: 0.65rem;
      display: inline-block;
      background: url('~@/assets/icon/today_ic_03.png') no-repeat left center;
      background-size: 0.54rem 0.54rem;
      font-size: 0.28rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #000000;
      margin-bottom: 0.15rem;
    }
    p{
      font-size: 0.32rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #000000;
    }
  }
}
</style>
